module.exports = __webpack_public_path__ + "static/media/map.d3e5fbbc.png";